/**
 * Table module - utilities for generating table structure
 */
export { generateTableBody, generateTableHead } from "./table-utils";
